import { createContext } from "react";

const UserSessionDetailsContext = createContext({});
export const UserSessionDetailsProvider = UserSessionDetailsContext.Provider;
export default UserSessionDetailsContext;
